import { VEHICLE_COLOR_PRESETS } from '@chukua/common';
import { ColorPicker, Form } from 'antd';
import type { Color } from 'antd/es/color-picker';

function presetName(hex: string): string {
  return VEHICLE_COLOR_PRESETS.find((preset) => preset.value.toLowerCase() === hex.toLowerCase())?.name ?? hex.toUpperCase();
}

/**
 * The colour a truck or trailer is painted, drawn on its 3D model everywhere it appears: the common
 * fleet colours first, any other as a custom pick. Stored as `#RRGGBB`. Shared by the truck and
 * trailer forms.
 */
export function VehicleColorField() {
  return (
    <Form.Item name="color" label="Colour" getValueFromEvent={(color: Color) => color.toHexString().toUpperCase()}>
      <ColorPicker
        disabledAlpha
        showText={(color) => presetName(color.toHexString())}
        presets={[{ label: 'Fleet colours', colors: VEHICLE_COLOR_PRESETS.map((preset) => preset.value) }]}
      />
    </Form.Item>
  );
}
